import React from "react";

function BackgroundImage({ image }) {
    return (
        <div className="carousel-slide-bg-img-container">
            <picture>
                {image.bgMobileAssetPath!=undefined || image.bgMobileAssetPath!="" ? <source srcSet={image.bgMobileAssetPath} media={"(max-width:767px)"}/> : ""}
                {/* in case, seperate background image required for tablet and md screen (Need implementation in openCMS)*/}
                {image.bgTabletAssetPath!=undefined || image.bgTabletAssetPath!="" ? <source srcSet={image.bgTabletAssetPath} media={"(max-width:1439px)"}/> : ""}
                <source srcSet={image.bgAssetPath} media={"(min-width:768px)"}/>
                <img
                    src={image.bgAssetPath}
                    alt={image.bgAltText}
                    className="carousel-slide-bg-img"
                />
            </picture>
        </div>
    );
}

export default BackgroundImage;
